import { render, staticRenderFns } from "./PricePointForm.template.vue?vue&type=template&id=2a0f3cc4&scoped=true&"
var script = {}
import style0 from "./PricePointForm.template.vue?vue&type=style&index=0&id=2a0f3cc4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f3cc4",
  null
  
)

export default component.exports